import anticAtlasUrl from "@assets/skeletons/antic.atlas?url";
import anticAtlasJsonUrl from "@assets/skeletons/antic.json?url";
import anticAtlasImgUrl from "@assets/skeletons/antic.webp?url";
import coinAtlasUrl from "@assets/skeletons/coin.atlas?url";
import coinAtlasJsonUrl from "@assets/skeletons/coin.json?url";
import coinAtlasImgUrl from "@assets/skeletons/coin.webp?url";
import coinRotateAtlasUrl from "@assets/skeletons/coin_rotate.atlas?url";
import coinRotateAtlasJsonUrl from "@assets/skeletons/coin_rotate.json?url";
import coinRotateAtlasImgUrl from "@assets/skeletons/coin_rotate.webp?url";
import coinSplashAtlasUrl from "@assets/skeletons/coin_splash.atlas?url";
import coinSplashAtlasJsonUrl from "@assets/skeletons/coin_splash.json?url";
import coinSplashAtlasImgUrl from "@assets/skeletons/coin_splash.webp?url";
import h1AtlasUrl from "@assets/skeletons/h1.atlas?url";
import h1AtlasJsonUrl from "@assets/skeletons/h1.json?url";
import h1AtlasImgUrl from "@assets/skeletons/h1.webp?url";
import h2AtlasUrl from "@assets/skeletons/h2.atlas?url";
import h2AtlasJsonUrl from "@assets/skeletons/h2.json?url";
import h2AtlasImgUrl from "@assets/skeletons/h2.webp?url";
import h3AtlasUrl from "@assets/skeletons/h3.atlas?url";
import h3AtlasJsonUrl from "@assets/skeletons/h3.json?url";
import h3AtlasImgUrl from "@assets/skeletons/h3.webp?url";
import h4AtlasUrl from "@assets/skeletons/h4.atlas?url";
import h4AtlasJsonUrl from "@assets/skeletons/h4.json?url";
import h4AtlasImgUrl from "@assets/skeletons/h4.webp?url";
import lowsAtlasUrl from "@assets/skeletons/lows.atlas?url";
import lowsAtlasJsonUrl from "@assets/skeletons/lows.json?url";
import lowsAtlasImgUrl from "@assets/skeletons/lows.webp?url";
import logoAtlasUrl from "@assets/skeletons/logo.atlas?url";
import logoAtlasJsonUrl from "@assets/skeletons/logo.json?url";
import logoAtlasImgUrl from "@assets/skeletons/logo.webp?url";
import scatterAtlasUrl from "@assets/skeletons/scatter.atlas?url";
import scatterAtlasJsonUrl from "@assets/skeletons/scatter.json?url";
import scatterAtlasImgUrl from "@assets/skeletons/scatter.webp?url";
import wildAtlasUrl from "@assets/skeletons/wild.atlas?url";
import wildAtlasJsonUrl from "@assets/skeletons/wild.json?url";
import wildAtlasImgUrl from "@assets/skeletons/wild.webp?url";
import winsAtlasUrl from "@assets/skeletons/wins.atlas?url";
import winsAtlasJsonUrl from "@assets/skeletons/wins.json?url";
import winsAtlasImgUrl from "@assets/skeletons/wins.webp?url";
import fireAtlasUrl from "@assets/skeletons/fire.atlas?url";
import fireAtlasJsonUrl from "@assets/skeletons/fire.json?url";
import fireAtlasImgUrl from "@assets/skeletons/fire.webp?url";
import bagAtlasUrl from "@assets/skeletons/bags.atlas?url";
import bagAtlasJsonUrl from "@assets/skeletons/bags.json?url";
import bagAtlasImgUrl from "@assets/skeletons/bags.webp?url";
import mainPanelAtlasUrl from "@assets/skeletons/main_panel.atlas?url";
import mainPanelAtlasJsonUrl from "@assets/skeletons/main_panel.json?url";
import mainPanelAtlasImg0Url from "@assets/skeletons/main_panel_0.webp?url";
import mainPanelAtlasImg1Url from "@assets/skeletons/main_panel_1.webp?url";
import mainPanelAtlasImg2Url from "@assets/skeletons/main_panel_2.webp?url";
import atlasLoadingJsonUrl from "@assets/sprites/atlas_loading.json?url";
import atlasLoadingImgUrl from "@assets/sprites/atlas_loading.webp?url";
import atlasGame0JsonUrl from "@assets/sprites/atlas_game_0.json?url";
import atlasGame0ImgUrl from "@assets/sprites/atlas_game_0.webp?url";
import atlasGame1JsonUrl from "@assets/sprites/atlas_game_1.json?url";
import atlasGame1ImgUrl from "@assets/sprites/atlas_game_1.webp?url";
import atlasUIJsonUrl from "@assets/sprites/atlas_ui.json?url";
import atlasUIImgUrl from "@assets/sprites/atlas_ui.webp?url";
import mainPanelBgImgUrl from "@assets/sprites/main_panel_bg.webp?url";
import fsBgHorizontalImgUrl from "@assets/sprites/fs_bg_horizontal.webp?url";
import fsBgVerticalImgUrl from "@assets/sprites/fs_bg_vertical.webp?url";
import loadingBgHorizontalImgUrl from "@assets/sprites/loading_bg_horizontal.webp?url";
import mainBgHorizontalImgUrl from "@assets/sprites/main_bg_horizontal.webp?url";
import cellImgUrl from "@assets/sprites/hold_panel_cell.webp?url";
import bagCellImgUrl from "@assets/sprites/hold_panel_bag.webp?url";
import cellPanelImgUrl from "@assets/sprites/hold_panel.webp?url";
import torchHandleImgUrl from "@assets/sprites/torch_handle.webp?url";
import gameFontUrl from "@assets/fonts/pirate_treasure_font.otf?url";
import uiFontUrl from "@assets/fonts/roboto_condensed_regular.ttf?url";
import winFontUrl from "@assets/fonts/win_font.fnt?url";
import winFontImgUrl from "@assets/fonts/win_font.webp?url";

// Background & Ambience
import sndAnticipationUrl from "@assets/audio/SND_Anticipation.wav?url";
import sndBackgroundUrl from "@assets/audio/SND_Background.wav?url";
import sndBonusBackgroundUrl from "@assets/audio/SND_Bonus_Background.wav?url";
import sndFSBackgroundUrl from "@assets/audio/SND_FSBackground.wav?url";
import sndFSIdleUrl from "@assets/audio/SND_FSIdle.wav?url";
import sndIdleUrl from "@assets/audio/SND_Idle.wav?url";
import sndIntroductionUrl from "@assets/audio/SND_Introduction.wav?url";

// Reels & Spin Actions
import sndSpinUrl from "@assets/audio/SND_Spin.wav?url";
import sndStopUrl from "@assets/audio/SND_Stop.wav?url";
import sndReelsMoveUrl from "@assets/audio/SND_ReelsMove.wav?url";
import sndCslSpinUrl from "@assets/audio/SND_CSL_Spin.wav?url";
import sndCslStopUrl from "@assets/audio/SND_CSL_Stop.wav?url";
import sndCslGenericUrl from "@assets/audio/SND_CSL_Generic.wav?url";

// Symbols & Scatters
import sndWildLandUrl from "@assets/audio/SND_WildLand.wav?url";
import sndWildLandExpand1Url from "@assets/audio/SND_WildLandExpand1.wav?url";
import sndWildLandExpand2Url from "@assets/audio/SND_WildLandExpand2.wav?url";
import sndWildLandExpand3Url from "@assets/audio/SND_WildLandExpand3.wav?url";
import sndWildLandExpand4Url from "@assets/audio/SND_WildLandExpand4.wav?url";
import sndWildLandExpand5Url from "@assets/audio/SND_WildLandExpand5.wav?url";
import sndScatterLand1Url from "@assets/audio/SND_ScatterLand1.wav?url";
import sndScatterLand2Url from "@assets/audio/SND_ScatterLand2.wav?url";
import sndScatterLand3Url from "@assets/audio/SND_ScatterLand3.wav?url";

// Win Celebrations
import sndWin1Url from "@assets/audio/SND_Win1.wav?url";
import sndWin2Url from "@assets/audio/SND_Win2.wav?url";
import sndWinHighlightUrl from "@assets/audio/SND_Win_Highlight.wav?url";
import sndBigWinUrl from "@assets/audio/SND_BigWin.wav?url";
import sndBigWinEndUrl from "@assets/audio/SND_BigWinEnd.wav?url";
import sndSuperWinUrl from "@assets/audio/SND_SuperWin.wav?url";
import sndSuperWinEndUrl from "@assets/audio/SND_SuperWinEnd.wav?url";
import sndMegaWinUrl from "@assets/audio/SND_MegaWin.wav?url";
import sndMegaWinEndUrl from "@assets/audio/SND_MegaWinEnd.wav?url";

// Bonus & Jackpots
import sndBonusCoinCollectUrl from "@assets/audio/SND_BonusCoinCollect.wav?url";
import sndBonusCoinLandUrl from "@assets/audio/SND_BonusCoinLand.wav?url";
import sndBonusStartButtonUrl from "@assets/audio/SND_BonusStartButton.wav?url";
import sndBonusTriggerUrl from "@assets/audio/SND_BonusTrigger.wav?url";
import sndFSTriggerUrl from "@assets/audio/SND_FSTrigger.wav?url";
import sndFSSummaryUrl from "@assets/audio/SND_FSSummary.wav?url";
import sndJackpotLandGrandUrl from "@assets/audio/SND_JackpotLand_Grand.wav?url";
import sndJackpotLandMajorUrl from "@assets/audio/SND_JackpotLand_Major.wav?url";
import sndJackpotLandMidiUrl from "@assets/audio/SND_JackpotLand_Midi.wav?url";
import sndJackpotLandMinorUrl from "@assets/audio/SND_JackpotLand_Minor.wav?url";

// UI & Counters
import sndCounterValueChangeUrl from "@assets/audio/SND_CounterValueChange.wav?url";
import sndCountUpUrl from "@assets/audio/SND_CountUp.wav?url";
import sndCountUpEndUrl from "@assets/audio/SND_CountUpEnd.wav?url";
import sndDialogScreenMoveUrl from "@assets/audio/SND_DialogScreen_Move.wav?url";

import { constants } from "@src/game/Constants";
import { EAssetType, TAssetData } from "@src/core/assets/Assets";

export const assetManifest = {
  anticAtlas: {
    bundle: constants.Bundles.SKELETONS,
    src: anticAtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: anticAtlasImgUrl,
  },
  anticAtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: anticAtlasJsonUrl,
    type: EAssetType.JSON,
  },
  coinAtlas: {
    bundle: constants.Bundles.SKELETONS,
    src: coinAtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: coinAtlasImgUrl,
  },
  coinAtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: coinAtlasJsonUrl,
    type: EAssetType.JSON,
  },
  coinRotateAtlas: {
    bundle: constants.Bundles.SKELETONS,
    src: coinRotateAtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: coinRotateAtlasImgUrl,
  },
  coinRotateAtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: coinRotateAtlasJsonUrl,
    type: EAssetType.JSON,
  },
  coinSplashAtlas: {
    bundle: constants.Bundles.SKELETONS,
    src: coinSplashAtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: coinSplashAtlasImgUrl,
  },
  coinSplashAtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: coinSplashAtlasJsonUrl,
    type: EAssetType.JSON,
  },
  h1Atlas: {
    bundle: constants.Bundles.SKELETONS,
    src: h1AtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: h1AtlasImgUrl,
  },
  h1AtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: h1AtlasJsonUrl,
    type: EAssetType.JSON,
  },
  h2Atlas: {
    bundle: constants.Bundles.SKELETONS,
    src: h2AtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: h2AtlasImgUrl,
  },
  h2AtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: h2AtlasJsonUrl,
    type: EAssetType.JSON,
  },
  h3Atlas: {
    bundle: constants.Bundles.SKELETONS,
    src: h3AtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: h3AtlasImgUrl,
  },
  h3AtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: h3AtlasJsonUrl,
    type: EAssetType.JSON,
  },
  h4Atlas: {
    bundle: constants.Bundles.SKELETONS,
    src: h4AtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: h4AtlasImgUrl,
  },
  h4AtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: h4AtlasJsonUrl,
    type: EAssetType.JSON,
  },
  lowsAtlas: {
    bundle: constants.Bundles.SKELETONS,
    src: lowsAtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: lowsAtlasImgUrl,
  },
  lowsAtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: lowsAtlasJsonUrl,
    type: EAssetType.JSON,
  },
  logoAtlas: {
    bundle: constants.Bundles.SKELETONS,
    src: logoAtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: logoAtlasImgUrl,
  },
  logoAtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: logoAtlasJsonUrl,
    type: EAssetType.JSON,
  },
  scatterAtlas: {
    bundle: constants.Bundles.SKELETONS,
    src: scatterAtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: scatterAtlasImgUrl,
  },
  scatterAtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: scatterAtlasJsonUrl,
    type: EAssetType.JSON,
  },
  wildAtlas: {
    bundle: constants.Bundles.SKELETONS,
    src: wildAtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: wildAtlasImgUrl,
  },
  wildAtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: wildAtlasJsonUrl,
    type: EAssetType.JSON,
  },
  winsAtlas: {
    bundle: constants.Bundles.SKELETONS,
    src: winsAtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: winsAtlasImgUrl,
  },
  winsAtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: winsAtlasJsonUrl,
    type: EAssetType.JSON,
  },
  fireAtlas: {
    bundle: constants.Bundles.SKELETONS,
    src: fireAtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: fireAtlasImgUrl,
  },
  fireAtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: fireAtlasJsonUrl,
    type: EAssetType.JSON,
  },
  bagAtlas: {
    bundle: constants.Bundles.SKELETONS,
    src: bagAtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: bagAtlasImgUrl,
  },
  bagAtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: bagAtlasJsonUrl,
    type: EAssetType.JSON,
  },
  mainPanelAtlas: {
    bundle: constants.Bundles.SKELETONS,
    src: mainPanelAtlasUrl,
    type: EAssetType.SPINE_ATLAS,
    imageSrc: [
      mainPanelAtlasImg0Url,
      mainPanelAtlasImg1Url,
      mainPanelAtlasImg2Url,
    ],
  },
  mainPanelAtlasJson: {
    bundle: constants.Bundles.SKELETONS,
    src: mainPanelAtlasJsonUrl,
    type: EAssetType.JSON,
  },
  atlasLoading: {
    bundle: constants.Bundles.SPRITES,
    src: atlasLoadingJsonUrl,
    type: EAssetType.SPRITESHEET,
    imageSrc: atlasLoadingImgUrl,
  },
  atlasGame0: {
    bundle: constants.Bundles.SPRITES,
    src: atlasGame0JsonUrl,
    type: EAssetType.SPRITESHEET,
    imageSrc: atlasGame0ImgUrl,
  },
  atlasGame1: {
    bundle: constants.Bundles.SPRITES,
    src: atlasGame1JsonUrl,
    type: EAssetType.SPRITESHEET,
    imageSrc: atlasGame1ImgUrl,
  },
  atlasUI: {
    bundle: constants.Bundles.SPRITES,
    src: atlasUIJsonUrl,
    type: EAssetType.SPRITESHEET,
    imageSrc: atlasUIImgUrl,
  },
  mainPanelBgImg: {
    bundle: constants.Bundles.SPRITES,
    src: mainPanelBgImgUrl,
    type: EAssetType.IMAGE,
  },
  bonusBgHorizontalImg: {
    bundle: constants.Bundles.SPRITES,
    src: fsBgHorizontalImgUrl,
    type: EAssetType.IMAGE,
  },
  bonusBgVerticalImg: {
    bundle: constants.Bundles.SPRITES,
    src: fsBgVerticalImgUrl,
    type: EAssetType.IMAGE,
  },
  loadingBgHorizontalImg: {
    bundle: constants.Bundles.SPRITES,
    src: loadingBgHorizontalImgUrl,
    type: EAssetType.IMAGE,
  },
  // loadingBgVerticalImg: {
  //   bundle: constants.Bundles.SPRITES,
  //   src: loadingBgVerticalImgUrl,
  // },
  mainBgHorizontalImg: {
    bundle: constants.Bundles.SPRITES,
    src: mainBgHorizontalImgUrl,
    type: EAssetType.IMAGE,
  },
  cellImg: {
    bundle: constants.Bundles.SPRITES,
    src: cellImgUrl,
    type: EAssetType.IMAGE,
  },
  bagCellImg: {
    bundle: constants.Bundles.SPRITES,
    src: bagCellImgUrl,
    type: EAssetType.IMAGE,
  },
  cellPanelImg: {
    bundle: constants.Bundles.SPRITES,
    src: cellPanelImgUrl,
    type: EAssetType.IMAGE,
  },
  torchHandleImg: {
    bundle: constants.Bundles.SPRITES,
    src: torchHandleImgUrl,
    type: EAssetType.IMAGE,
  },
  // mainBgVerticalImg: {
  //   bundle: constants.Bundles.SPRITES,
  //   src: mainBgVerticalImgUrl,
  // },
  gameFont: {
    bundle: constants.Bundles.FONTS,
    src: gameFontUrl,
    type: EAssetType.DOCUMENT_FONT,
  },
  uiFont: {
    bundle: constants.Bundles.FONTS,
    src: uiFontUrl,
    type: EAssetType.DOCUMENT_FONT,
  },
  winFont: {
    bundle: constants.Bundles.FONTS,
    src: winFontUrl,
    type: EAssetType.BITMAP_FONT,
    imageSrc: winFontImgUrl,
  },

  // --- Audio Assets ---
  // Added
  sndAnticipation: {
    bundle: constants.Bundles.AUDIO,
    src: sndAnticipationUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndBackground: {
    bundle: constants.Bundles.AUDIO,
    src: sndBackgroundUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndBigWin: {
    bundle: constants.Bundles.AUDIO,
    src: sndBigWinUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndBigWinEnd: {
    bundle: constants.Bundles.AUDIO,
    src: sndBigWinEndUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndBonusBackground: {
    bundle: constants.Bundles.AUDIO,
    src: sndBonusBackgroundUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndBonusCoinCollect: {
    bundle: constants.Bundles.AUDIO,
    src: sndBonusCoinCollectUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndBonusCoinLand: {
    bundle: constants.Bundles.AUDIO,
    src: sndBonusCoinLandUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndBonusStartButton: {
    bundle: constants.Bundles.AUDIO,
    src: sndBonusStartButtonUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndBonusTrigger: {
    bundle: constants.Bundles.AUDIO,
    src: sndBonusTriggerUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndCounterValueChange: {
    bundle: constants.Bundles.AUDIO,
    src: sndCounterValueChangeUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndCountUp: {
    bundle: constants.Bundles.AUDIO,
    src: sndCountUpUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndCountUpEnd: {
    bundle: constants.Bundles.AUDIO,
    src: sndCountUpEndUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndCslGeneric: {
    bundle: constants.Bundles.AUDIO,
    src: sndCslGenericUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndCslSpin: {
    bundle: constants.Bundles.AUDIO,
    src: sndCslSpinUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndCslStop: {
    bundle: constants.Bundles.AUDIO,
    src: sndCslStopUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndDialogScreenMove: {
    bundle: constants.Bundles.AUDIO,
    src: sndDialogScreenMoveUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndFSBackground: {
    bundle: constants.Bundles.AUDIO,
    src: sndFSBackgroundUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndFSIdle: {
    bundle: constants.Bundles.AUDIO,
    src: sndFSIdleUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndFSSummary: {
    bundle: constants.Bundles.AUDIO,
    src: sndFSSummaryUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndFSTrigger: {
    bundle: constants.Bundles.AUDIO,
    src: sndFSTriggerUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndIdle: {
    bundle: constants.Bundles.AUDIO,
    src: sndIdleUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndIntroduction: {
    bundle: constants.Bundles.AUDIO,
    src: sndIntroductionUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndJackpotLandGrand: {
    bundle: constants.Bundles.AUDIO,
    src: sndJackpotLandGrandUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndJackpotLandMajor: {
    bundle: constants.Bundles.AUDIO,
    src: sndJackpotLandMajorUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndJackpotLandMidi: {
    bundle: constants.Bundles.AUDIO,
    src: sndJackpotLandMidiUrl,
    type: EAssetType.AUDIO,
  },
  sndJackpotLandMinor: {
    bundle: constants.Bundles.AUDIO,
    src: sndJackpotLandMinorUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndMegaWin: {
    bundle: constants.Bundles.AUDIO,
    src: sndMegaWinUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndMegaWinEnd: {
    bundle: constants.Bundles.AUDIO,
    src: sndMegaWinEndUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndReelsMove: {
    bundle: constants.Bundles.AUDIO,
    src: sndReelsMoveUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndScatterLand1: {
    bundle: constants.Bundles.AUDIO,
    src: sndScatterLand1Url,
    type: EAssetType.AUDIO,
  },
  // Added
  sndScatterLand2: {
    bundle: constants.Bundles.AUDIO,
    src: sndScatterLand2Url,
    type: EAssetType.AUDIO,
  },
  // Added
  sndScatterLand3: {
    bundle: constants.Bundles.AUDIO,
    src: sndScatterLand3Url,
    type: EAssetType.AUDIO,
  },
  // Added
  sndSpin: {
    bundle: constants.Bundles.AUDIO,
    src: sndSpinUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndStop: {
    bundle: constants.Bundles.AUDIO,
    src: sndStopUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndSuperWin: {
    bundle: constants.Bundles.AUDIO,
    src: sndSuperWinUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndSuperWinEnd: {
    bundle: constants.Bundles.AUDIO,
    src: sndSuperWinEndUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndWildLand: {
    bundle: constants.Bundles.AUDIO,
    src: sndWildLandUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndWildLandExpand1: {
    bundle: constants.Bundles.AUDIO,
    src: sndWildLandExpand1Url,
    type: EAssetType.AUDIO,
  },
  // Added
  sndWildLandExpand2: {
    bundle: constants.Bundles.AUDIO,
    src: sndWildLandExpand2Url,
    type: EAssetType.AUDIO,
  },
  // Added
  sndWildLandExpand3: {
    bundle: constants.Bundles.AUDIO,
    src: sndWildLandExpand3Url,
    type: EAssetType.AUDIO,
  },
  // Added
  sndWildLandExpand4: {
    bundle: constants.Bundles.AUDIO,
    src: sndWildLandExpand4Url,
    type: EAssetType.AUDIO,
  },
  // Added
  sndWildLandExpand5: {
    bundle: constants.Bundles.AUDIO,
    src: sndWildLandExpand5Url,
    type: EAssetType.AUDIO,
  },
  // Added
  sndWinHighlight: {
    bundle: constants.Bundles.AUDIO,
    src: sndWinHighlightUrl,
    type: EAssetType.AUDIO,
  },
  // Added
  sndWin1: {
    bundle: constants.Bundles.AUDIO,
    src: sndWin1Url,
    type: EAssetType.AUDIO,
  },
  // Added
  sndWin2: {
    bundle: constants.Bundles.AUDIO,
    src: sndWin2Url,
    type: EAssetType.AUDIO,
  },
} as const satisfies Record<string, TAssetData>;

export const AssetKeys = Object.fromEntries(
  Object.keys(assetManifest).map((key) => [key, key]),
) as { [K in keyof typeof assetManifest]: K };
